var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBtcfi = function SvgIconBtcfi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4068DF",
    fillOpacity: 0.6,
    d: "M20.03 20.336c4.924-4.768 5.322-12.365.887-16.968-4.435-4.604-12.022-4.471-16.947.296s-5.322 12.365-.887 16.968c4.434 4.604 12.022 4.471 16.947-.296"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "m3.147 14.928-.073-.044zM11.275 22.4q.06 0 .123-.002a24 24 0 0 1-.865-.025q.366.027.743.027zM5.194 8.658c1.841 0 3.23 1.497 3.101 3.343-.125 1.787-1.625 3.247-3.392 3.338 1.438-.058 2.703-.826 3.907-1.875a1.9 1.9 0 0 1-.514-1.463c.079-1.128 1.054-2.043 2.18-2.043.518 0 .977.194 1.314.513.964-.994 1.949-1.934 3.016-2.587a5.3 5.3 0 0 1 2.917-.897c4.514 0 4.694 3.8 4.665 4.783.27-5.637-4.009-10.169-9.662-10.169s-10.698 4.656-11.1 10.4c.13-1.846 1.726-3.343 3.568-3.343M2.975 14.821l-.005-.004zM4.554 15.34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M14.806 7.884c.832-.509 1.714-.843 2.675-.89a5.3 5.3 0 0 0-2.675.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M14.806 7.884c.832-.509 1.714-.843 2.675-.89a5.3 5.3 0 0 0-2.675.89",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M8.295 12c.129-1.846-1.26-3.343-3.101-3.343-1.842 0-3.439 1.497-3.567 3.343v.006q-.005.076-.007.151c-.02 1.043.479 2.065 1.35 2.66l.005.004q.048.033.1.064a2 2 0 0 0 .109.065 3.1 3.1 0 0 0 1.543.394q.089 0 .176-.005c1.766-.092 3.267-1.55 3.391-3.338zM22.387 11.77l-.013.23s.01-.085.013-.23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M17.723 6.986c2.762 0 4.845 2.245 4.652 5.014q.008-.116.012-.23c.03-.985-.151-4.784-4.665-4.784z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M17.723 6.986c2.762 0 4.845 2.245 4.652 5.014q.008-.116.012-.23c.03-.985-.151-4.784-4.665-4.784zM4.904 15.34q-.089.003-.176.004.089 0 .176-.005"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M4.904 15.34q-.089.003-.176.004.089 0 .176-.005",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M4.904 15.34q-.089.003-.176.004.089 0 .176-.005M4.404 15.327h-.016z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M4.404 15.327h-.016z",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M4.404 15.327h-.016zM3.184 14.95l-.037-.022z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "m3.184 14.95-.037-.022z",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "m3.184 14.95-.037-.022zM1.62 12.157c-.026 1.118.505 2.092 1.35 2.66-.872-.595-1.37-1.617-1.35-2.66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M1.62 12.157c-.026 1.118.505 2.092 1.35 2.66-.872-.595-1.37-1.617-1.35-2.66",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M1.62 12.157c-.026 1.118.505 2.092 1.35 2.66-.872-.595-1.37-1.617-1.35-2.66M3.074 14.884q-.05-.03-.099-.064z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M3.074 14.884q-.05-.03-.099-.064z",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M3.074 14.884q-.05-.03-.099-.064z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3861D1",
    d: "M17.723 6.986q-.121 0-.243.006c-.96.048-1.842.383-2.674.891-1.067.653-2.052 1.593-3.015 2.587a1.9 1.9 0 0 0-1.314-.513c-1.125 0-2.102.915-2.18 2.043a1.9 1.9 0 0 0 .513 1.463c-1.204 1.05-2.469 1.817-3.906 1.875C6.67 15.246 8.17 13.788 8.295 12c.125-1.787-1.26-3.343-3.101-3.343-1.842 0-3.439 1.497-3.567 3.343v.006q-.005.076-.007.151c-.02 1.043.479 2.065 1.35 2.66l.005.004q.048.033.1.064.035.023.072.044l.037.021a3.1 3.1 0 0 0 1.219.378h-.016a3.04 3.04 0 0 1-1.417-.51c-.845-.569-1.376-1.543-1.35-2.66q0-.076.007-.152V12c-.383 5.493 3.55 9.99 8.906 10.373q.42.02.865.025c5.677-.066 10.578-4.696 10.976-10.398.194-2.769-1.889-5.014-4.651-5.014"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M5.194 8.658c1.045 0 1.944.483 2.503 1.237.024-1.37-.894-2.496-2.184-2.758C6.518 6.65 7.257 5.643 7.337 4.48a2.85 2.85 0 0 0-.21-1.305A11.55 11.55 0 0 0 2.68 8.045a11 11 0 0 0-1.053 3.956 3.5 3.5 0 0 1 .223-1.006c.52-1.355 1.851-2.337 3.344-2.337"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M14.806 7.884c-1.067.653-2.052 1.593-3.016 2.587-.994 1.026-1.966 2.11-2.98 2.993-1.204 1.05-2.47 1.817-3.907 1.875a3.4 3.4 0 0 1-.5-.01q-.007 0-.015-.002a3.04 3.04 0 0 1-1.412-.506q-.003 0-.005-.004c-.845-.568-1.376-1.542-1.35-2.66q0-.075.007-.15V12c-.383 5.493 3.55 9.99 8.906 10.373q.42.02.864.025c5.677-.066 10.58-4.695 10.977-10.398.194-2.77-1.89-5.015-4.651-5.015q-.121 0-.243.006c-.96.048-1.842.383-2.674.891"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M12.235 1.958c5.532 0 9.82 3.983 10.135 9.133.024.281.025.517.021.678C22.661 6.132 18.382 1.6 12.73 1.6c-1.897 0-3.71.511-5.302 1.402a11.65 11.65 0 0 1 4.808-1.044"
  })));
};
export default SvgIconBtcfi;